import Wishlist, { WishlistProps } from '~/components/UI/Wishlist'

import withAuthentication from '~/hocs/withAuthentication'

import getWishlistPageStaticPropsFunction from '~/data/wishlist-page-data'

function WishlistPage(props: WishlistProps) {
  return <Wishlist {...props} />
}

export default withAuthentication(WishlistPage)

export const getStaticProps = getWishlistPageStaticPropsFunction()
